module.exports = __webpack_public_path__ + "static/img/02.cbaffa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/02.jpg
// module id = FYzy
// module chunks = 0